import { Tooltip } from '@maxtropy/components';
import { RenderFunction } from 'antd/es/_util/getRenderPropValue';

interface CustomTooltipProps {
  title?: React.ReactNode | RenderFunction;
  children?: React.ReactNode;
  className?: string;
  placement?: 'top' | 'left' | 'right' | 'bottom' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
  trigger?: 'click' | 'hover' | 'focus' | 'contextMenu' | ('click' | 'hover' | 'focus' | 'contextMenu')[];
}

/**
 * 兼容全屏状态下 popup 框不显示问题
 */
const CustomTooltip = (props: CustomTooltipProps) => {
  return (
    <Tooltip
      getPopupContainer={() => document.getElementById('full_screen_box') ?? document.body}
      title={props.title}
      overlayClassName={props.className}
      placement={props.placement ?? 'top'}
      arrow={false}
      trigger={props.trigger ?? ['hover']}
    >
      {props.children}
    </Tooltip>
  );
};

export default CustomTooltip;
